import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import WithKioskProp from '../../hoc/WithKioskProp';
import * as reservationSelectors from '../selectors';
import WithBookNoPayQuery from '../../hoc/WithBookNoPayQuery';
import * as servicesSelectors from '../../services/selectors';

export default compose(
  WithKioskProp,
  withRouter,
  WithBookNoPayQuery,
  connect(
    (state, ownProps) => {
      const serviceCost = reservationSelectors.getServicesCost(state);
      const taxes = reservationSelectors.getTaxBreakdownAmount(state);
      const taxBreakdown = reservationSelectors.getTaxBreakdown(state);
      const totalAmount = reservationSelectors.getTotalAmount(state);

      return {
        servicesNamesShort: servicesSelectors.getServiceNameShort(state, ownProps.params.serviceId),
        servicesNamesLong: servicesSelectors.getServiceNameLong(state, ownProps.params.serviceId),
        taxes,
        totalAmount,
        costWithTaxes: serviceCost + taxes,
        serviceCost,
        taxBreakdown,
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withCostWithoutFees.js